import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import PageService from '../../../services/pageService/PageService.js';
import DOMPurify from "dompurify";
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap
import { useBanner } from '../../../context/BannerContext';
import '../../../assets/CSS/page-theme.css'; // Import custom CSS for the component

const CustomPage = () => {
  const { pageName } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { toggleBanner } = useBanner();

  // States for loading, content, and styles
  const [isLoading, setIsLoading] = useState(true);
  const [pageContent, setPageContent] = useState('');
  const [pageCSS, setPageCSS] = useState('');

  useEffect(() => {
    // Hide the banner when this component mounts
    toggleBanner(false);
    
    // Show the banner again when component unmounts
    return () => toggleBanner(true);
  }, [toggleBanner]);

  useEffect(() => {
    document.title = "Preview website - " + pageName;
    
    const fixedPageName = pageName.includes('&') 
      ? pageName.replace(/&/g, '%26') 
      : pageName;
  
    fetchPageContent(decodeURIComponent(fixedPageName));
  }, [pageName]);
  

  const fetchPageContent = (name) => {
    const fixedName = name.includes('&') 
      ? name.replace(/&/g, '%26') 
      : name;
  
    PageService.GetPageByNameAndDepartmentId(fixedName)
      .then(response => {
        const res = response.data;
        if (res.status) {
          setPageContent(DOMPurify.sanitize(res.object.page.content));
          setPageCSS(res.object.page.css);
        } else {
          console.log('No data found');
        }
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error fetching page content:', error);
        setIsLoading(false);
      });
  };
  

  return (
    <div>
      <style>{pageCSS}</style>

      {/* Loader */}
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {/* Render HTML safely only when data is loaded */}
      {!isLoading && <div dangerouslySetInnerHTML={{ __html: pageContent }} />}
    </div>
  );
};

export default CustomPage;
